import React from 'react';
import { Select } from '@material-ui/core';
import { UNSELECTED_RIDING_DATE_STRING } from './useForm';

interface Props {
  flightPattern: string[];
  selectFlightData: string;
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

const SelectFlight: React.FC<Props> = (props: Props) => {
  const defaultValue = UNSELECTED_RIDING_DATE_STRING;

  return (
    <Select
      native
      onChange={props.onChange}
      value={props.selectFlightData}
    >
      <option value={defaultValue}>
        {defaultValue}
      </option>
      {props.flightPattern.map((pattern, index) => (
        <option key={index} value={pattern}>
          {pattern}
        </option>
      ))}
    </Select>
  );
};

export default SelectFlight;
